import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { signOut } from "aws-amplify/auth";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import Link from "@material-ui/core/Link";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";

import { USER_LOGOUT } from "../../constants/actionTypes";
import colors from "../../assets/style/colors";

const styles = {
  link: {
    color: colors.black87,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
  menuItem: {
    height: "40px",
    paddingLeft: "16px",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
      color: colors.primary,
    },
  },
  listItemIcon: {
    minWidth: "36px",
  },
};

const CustomSignOut = (props) => {
  const { classes } = props;

  return (
    <Link
      onClick={async () => {
        props.history.push("/");
        try {
          await signOut();
        } finally {
          props.dispatch({ type: USER_LOGOUT });
        }
      }}
      className={classes.link}
    >
      <MenuItem className={classes.menuItem}>
        <ListItemText style={{ fontSize: "0.875em" }} disableTypography>
          {I18n.get(`auth_${props.item}`)}
        </ListItemText>
      </MenuItem>
    </Link>
  );
};

export default withRouter(connect()(withStyles(styles)(CustomSignOut)));
